
// flaky does not consider new lines or if not br does not consider if coming from quill text editor
export function convertHtmlToPreFormattedText(html: string): string {
  let tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  let formattedText = tempDiv.textContent || tempDiv.innerText || "";

  return formattedText
}
